import { render, staticRenderFns } from "./ToWatchPage.vue?vue&type=template&id=ef8ff7c0&scoped=true"
import script from "./ToWatchPage.vue?vue&type=script&lang=js"
export * from "./ToWatchPage.vue?vue&type=script&lang=js"
import style0 from "./ToWatchPage.vue?vue&type=style&index=0&id=ef8ff7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8ff7c0",
  null
  
)

export default component.exports